<div>
    <div fxLayout="column" fxLayout.gt-sm="row" style="text-align: center;" fxLayoutGap="15px"
        *ngFor="let data of pricedetail">
        <div contentAnim [aniName]="item.customField36" fxFlex="100" fxFlex.gt-sm="25" style="border: 1px solid gray;border-radius: 20px">
            <h3><b>{{data.title1}}</b></h3>

            <div *ngIf="!isChecked">
                <h4><b>₹ {{data.s_price_annualy}}</b></h4>
                <h6>{{data.s_charge_year}}</h6>
            </div>

            <button (click)="openInNewWindow(data.p_button)" mat-raised-button
                color="primary">{{data.s_button}}</button>
            <h5><b>{{data.s_subtitle}}</b></h5>

            <div *ngFor="let subdata of data.list_detail" style="margin-bottom: 10px;">
                <div class="pricelist" *ngIf="subdata.starters">
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6 style="margin-bottom: 0px;">&#160;&#160;{{subdata.starters}}</h6>
                </div>
            </div>
        </div>

        <div contentAnim [aniName]="item.customField37" fxFlex="100" fxFlex.gt-sm="25" [style.background-color]="data.column_color"
            style="border: 1px solid gray;border-radius: 20px;" class="txtcolor">
            <h3><b>{{data.title2}}</b></h3>

            <div *ngIf="!isChecked">
                <h4><b>₹ {{data.p_price_annualy}} </b></h4>
                <h6 class="txtcolor">{{data.p_charge_year}}</h6>
            </div>

            <button (click)="openInNewWindow(data.p_button)" mat-raised-button>{{data.s_button}}</button>
            <h5 class="txtcolor"><b>{{data.p_subtitle}}</b></h5>

            <div *ngFor="let subdatas of data.list_detail" style="margin-bottom: 10px;">
                <div class="pricelist" *ngIf="subdatas.professions">
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6 style="margin-bottom: 0px;" class="txtcolor">&#160;&#160;{{subdatas.professions}}</h6>
                </div>
            </div>

        </div>

        <div contentAnim [aniName]="item.customField38" fxFlex="100" fxFlex.gt-sm="25" style="border: 1px solid gray;border-radius: 20px">
            <h3><b>{{data.title3}}</b></h3>

            <div *ngIf="!isChecked">
                <h4><b>₹ {{data.a_price_annualy}} </b></h4>
                <h6>{{data.a_charge_year}}</h6>
            </div>

            <button (click)="openInNewWindow(data.p_button)" mat-raised-button
                color="primary">{{data.s_button}}</button>
            <h5><b>{{data.a_subtitle}}</b></h5>

            <div *ngFor="let subdataz of data.list_detail" style="margin-bottom: 10px;">
                <div class="pricelist" *ngIf="subdataz.advanceds">
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6 style="margin-bottom: 0px;">&#160;&#160;{{subdataz.advanceds}}</h6>
                </div>
            </div>

        </div>

        <div contentAnim [aniName]="item.customField37" fxFlex="100" fxFlex.gt-sm="25" [style.background-color]="data.column_color"
            style="border: 1px solid gray;border-radius: 20px;" class="txtcolor">
            <h3><b>{{data.title4}}</b></h3>

            <div *ngIf="!isChecked">
                <h4><b>₹ {{data.u_price_annualy}} </b></h4>
                <h6>{{data.u_charge_year}}</h6>
            </div>

            <button (click)="openInNewWindow(data.p_button)" mat-raised-button>{{data.s_button}}</button>
            <h5><b>{{data.a_subtitle}}</b></h5>

            <div *ngFor="let subdataz of data.list_detail" style="margin-bottom: 10px;">
                <div class="pricelist" *ngIf="subdataz.ultimates">
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6 style="margin-bottom: 0px;">&#160;&#160;{{subdataz.ultimates}}</h6>
                </div>
            </div>

        </div>
    </div>

</div>